export type StepInfo = {
  id: number
  name: string
  isCompleted: boolean
  completedAt: Date
  dueDate: Date
  description?: string
  criterion?: string
}

export type GoalInfo = {
  id: number
  name: string
  isCompleted: boolean
  completedAt: Date
  dueDate: Date
  description?: string
  criterion?: string
  steps?: StepInfo[]
}

export type IndividualPlanInfo = {
  id: number
  name: string
  isClosed: boolean
  closedAt: Date
  dueDate: Date
  description?: string
  contractedGoal?: string
  goals?: GoalInfo[]
}

export type ProgramEnrollmentInfo = {
  id: number
  programId: number
  programName: string
  isTerminated: boolean
  isArchived: boolean
  archivedAt: Date
  dueDate?: Date
  contractedGoal?: string
  individualPlans?: IndividualPlanInfo[]
}

export class ClientIPList {
  static serviceName = 'features/client-ip/list'
  programEnrollment?: ProgramEnrollmentInfo[]
}
